import { render, staticRenderFns } from "./ExcelBtn.vue?vue&type=template&id=473faff2&scoped=true&"
import script from "./ExcelBtn.vue?vue&type=script&lang=ts&"
export * from "./ExcelBtn.vue?vue&type=script&lang=ts&"
import style0 from "./ExcelBtn.vue?vue&type=style&index=0&id=473faff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473faff2",
  null
  
)

export default component.exports